import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {useIntl} from 'react-intl';
import {PageTitle} from '../../../../_metronic/layout/core';
import Level3Title from '../../../common/components/title/Level3Title';
import Stepper from '../Stepper/Stepper';
import {useQuery} from 'react-query';
import {DetailedOrder, OrderMessage} from '../../../interfaces/order';
import {getOrderDetails, getOrderMessages} from '../api';
import Loading from '../../../common/components/Loading';
import DetailsBloc from './DetailsBloc';
import SecuredComponent from '../../../modules/auth/authorization/SecuredComponent';
import {useEffect, useRef, useState} from 'react';
import OrderTrackingConversation from '../mail-history/ticket-messages/OrderTrackingConversation';
import {Step} from '../../../types/Stepper';
import {isNotFoundError, NOT_FOUND_ROUTE} from '../../../common/tools/httpError';
import {findSystemById} from '../../../common/tools/resource';

const OrderDetails = (): JSX.Element => {
    const intl = useIntl();
    const {id: orderId} = useParams();
    const messagesRef = useRef<HTMLDivElement | null>(null);
    const urlHash = useLocation().hash;
    const [messages, setMessages] = useState<OrderMessage[]>();
    const navigate = useNavigate();

    useEffect(() => {
        // Horrible à enlever problème à résoudre HELP
        setTimeout(() => {
            if (messagesRef.current && urlHash === '#tracking-messages') {
                messagesRef.current.scrollIntoView({behavior: 'smooth'});
            }
        }, 1000);
    }, [urlHash]);

    const {isLoading: isOrderDetailsLoading, data: order} = useQuery<DetailedOrder>(
        ['get-order-details', orderId],
        async () => getOrderDetails(orderId ?? ''),
        {
            onError: (error) => {
                if (isNotFoundError(error)) {
                    navigate(NOT_FOUND_ROUTE, {replace: true});
                    return;
                }
                console.error(error);
                navigate('/');
            },
        }
    );

    const {isLoading: isMessagesLoading, data: orderMessages} = useQuery<OrderMessage[]>(
        [orderId, 'order-message-history', findSystemById(orderId ?? '', 'orders')],
        () => getOrderMessages(orderId ?? '')
    );

    useEffect(() => setMessages(orderMessages), [orderMessages]);

    const updateMessagesByLabel = async (label: Step) => {
        getOrderMessages(orderId ?? '', label).then((orderMessages) => {
            setMessages(orderMessages);
            if (messagesRef.current !== null) {
                messagesRef.current.scrollIntoView({behavior: 'smooth'});
            }
        });
    };

    if (orderId === undefined) {
        return <></>;
    }

    if (isOrderDetailsLoading) {
        return <Loading />;
    }

    return (
        <>
            <PageTitle
                // breadcrumbs={[
                //     {
                //         title: intl.formatMessage({id: 'MENU.ORDER_TRACKING'}),
                //         path: 'orders/in-progress',
                //         isActive: true,
                //     },
                // ]}
            >
                {intl.formatMessage({id: 'MENU.ORDER_TRACKING.ORDER_DETAILS'})}
            </PageTitle>

            <div className="d-flex flex-row">
                <div className="d-flex align-items-center mt-2 ps-6">
                    <Level3Title
                        title={`${intl.formatMessage({
                            id: 'ORDER_TRACKING.ORDER.ORDER',
                        })} ${orderId}`}
                    />
                </div>
            </div>
            <Stepper
                title={order?.description ?? ''}
                status={order?.status ?? null}
                filterMessagesOnClick={updateMessagesByLabel}
            />
            <div className="row">
                {order !== undefined && (
                    <div className="col-lg-6">
                        <DetailsBloc
                            {...order}
                            blocTitle={intl.formatMessage({id: 'ORDERS.DETAILS.TITLE'})}
                        />
                    </div>
                )}
                <SecuredComponent requiredPermissions={['voirNotificationsClients']}>
                    <div className="col-lg-6">
                        <div id="tracking-messages" ref={messagesRef}>
                            {isMessagesLoading ? (
                                <Loading />
                            ) : (
                                <OrderTrackingConversation messages={messages ?? []} />
                            )}
                        </div>
                    </div>
                </SecuredComponent>
            </div>
        </>
    );
};

export default OrderDetails;
